import axios from 'axios';
import { fetchGlobalBannersSuccess, fetchBillboardsSuccess, fetchRankingBannersSuccess } from '../actions/fetch';

export const operationFetchGlobalBanners = (hash) => async (dispatch) => {
	const endpoint = `${process.env.REACT_APP_API}/banners/${hash}`;

	axios
		.get(endpoint, {
			accept: 'application/json',
		})
		.then((response) => {
			dispatch(fetchGlobalBannersSuccess(response.data));
		})
		.catch((error) => {
			let errorData = 'error';
			if (error.response && error.response.data && error.response.data.message) {
				errorData = error.response.data.message;
			}
			// eslint-disable-next-line
			console.log(errorData);
		});
};

export const operationFetchBillboards = (hash) => async (dispatch) => {
	const endpoint = `${process.env.REACT_APP_API}/banners/${hash}`;

	axios
		.get(endpoint, {
			accept: 'application/json',
		})
		.then((response) => {
			dispatch(fetchBillboardsSuccess(response.data));
		})
		.catch((error) => {
			let errorData = 'error';
			if (error.response && error.response.data && error.response.data.message) {
				errorData = error.response.data.message;
			}
			// eslint-disable-next-line
			console.log(errorData);
		});
};

export const operationFetchRankingPartners = ({ hash, slug }) => async (dispatch) => {
	const endpoint = `${process.env.REACT_APP_API}/banners/${hash}`;

	axios
		.get(endpoint, {
			accept: 'application/json',
		})
		.then((response) => {
			dispatch(fetchRankingBannersSuccess({ id: slug, data: response.data }));
		})
		.catch((error) => {
			let errorData = 'error';
			if (error.response && error.response.data && error.response.data.message) {
				errorData = error.response.data.message;
			}
			// eslint-disable-next-line
			console.log(errorData);
		});
};
